import { cx } from "@emotion/css";
import useDeviceType from "hooks/useDeviceType";
import useOrders from "pages/Dashboard/hooks/useOrders";
import { PropTypes } from "prop-types";
import { useMemo } from "react";
import styles from "./DashboardLayout.styles";

const DashboardLayout = ({ pageHeaderSection, listSection, mapSection, fabSection, modalsSection, children }) => {
  const { isMobile, isDesktop } = useDeviceType();

  const [, , { isOrderListEmpty, isFiltersApplied }] = useOrders();

  const isDashboardEmpty = useMemo(() => !isFiltersApplied && isOrderListEmpty, [isFiltersApplied, isOrderListEmpty]);

  return (
    <div
      className={cx(
        styles.container(!isDesktop),
        isMobile && "container",
        "d-flex flex-1 h-fit flex-wrap align-items-stretch justify-content-end overflow-hidden"
      )}
    >
      <div
        className={cx(
          styles.container(!isDesktop),
          "d-flex flex-column col-md-6 col-12 pt-md-4 pt-2 pb-md-3 pb-2 px-2 px-md-5"
        )}
      >
        {pageHeaderSection}

        {!isDashboardEmpty && listSection}

        {!isDashboardEmpty && (
          <div className={cx(styles.fabSection, "position-absolute d-flex flex-column align-items-end gap-3")}>
            {fabSection}
          </div>
        )}
      </div>

      <div className="d-flex flex-column col-md-6 col-12 px-0">{!isDashboardEmpty && mapSection}</div>

      {children}

      {modalsSection}
    </div>
  );
};

DashboardLayout.defaultProps = {
  modalsSection: null,
};

DashboardLayout.propTypes = {
  pageHeaderSection: PropTypes.node.isRequired,
  listSection: PropTypes.node.isRequired,
  mapSection: PropTypes.node.isRequired,
  fabSection: PropTypes.node.isRequired,
  modalsSection: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
